/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const ProblemInternalServerErrorType: core.serialization.Schema<
    serializers.ProblemInternalServerErrorType.Raw,
    Truvity.ProblemInternalServerErrorType
> = core.serialization.enum_(['/internal-server-error']);

export declare namespace ProblemInternalServerErrorType {
    export type Raw = '/internal-server-error';
}
